import type { PricingList } from 'api/types/pricing.types';
import { createSelectors } from 'utils/create-selectors';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export interface UserInformation {}

interface PricingUIStore {
  pricingType: PricingList.ServiceTypes | undefined;
}

interface PricingUIStoreActions {
  setPricingType: (pricingType: PricingList.ServiceTypes | undefined) => void;
}

const initialState: PricingUIStore = {
  pricingType: undefined,
};

const usePricingUIStoreBase = create<PricingUIStore & PricingUIStoreActions>()(
  subscribeWithSelector((set) => ({
    ...initialState,
    setPricingType: (pricingType) => set({ pricingType }),
  }))
);

export const usePricingUIStore = createSelectors(usePricingUIStoreBase);
